<template>
  <div class="addzl">
    <div class="title">{{ $t("zlfk.basic") }}</div>
    <div class="zl-form">
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic"
        :label-width="labelWidth"
      >
        <el-form-item
          prop="theme"
          :label="$t('zlfk.basic')+':'"
          :rules="{
            required: true,
            message: $t('zlfk.themenone'),
            trigger: 'blur',
          }"
        >
          <el-input
            type="textarea"
            :placeholder="$t('placeholder.enter')"
            :autosize="{ minRows: 4, maxRows: 4 }"
            maxlength="500"
            show-word-limit
            v-model="dynamicValidateForm.theme"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('zlfk.vin')+':'"
          prop="vin"
          :rules="{
            required: true,
            message: $t('zlfk.vinnone'),
            trigger: 'blur',
          }"
        >
          <el-input v-model="dynamicValidateForm.vin" :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button
          type="primary"
          @click="submitForm('dynamicValidateForm')"
          >{{ $t("zlfk.submit") }}</el-button
        >

        <el-button type="primary" plain @click="handleReset">{{
          $t("home.reset")
        }}</el-button>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="620px">
      <span>{{ dialogContent }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="loading"
          @click="confitmDialog"
          >{{ $t("seek.confirm") }}</el-button
        >
        <el-button
          v-show="type == 0"
          :disabled="loading"
          type="primary"
          plain
          @click="dialogShow = false"
          >{{ $t("zlfk.backUpdate") }}</el-button
        >
        <el-button
          v-show="type == 1"
          :disabled="loading"
          type="primary"
          plain
          @click="dialogShow = false"
          >{{ $t("zlfk.backto") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- <myloading :width="(windowWidth-18)" :height='(windowHeight-152)' v-show="loading"/> -->
  </div>
</template>
<script>
import myloading from "@/components/load";
import { newFeedback } from "@/api/feedback";
export default {
  components: {
    myloading,
  },
  data() {
    return {
      loading: false,
      type: "",
      dialogShow: false,
      dialogTitle: "",
      dialogContent: "",
      dynamicValidateForm: {
        vin: "",
        theme: "",
      },
      windowWidth: "",
      windowHeight: "",
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        "zh": "110px",
        "en": "205px",
        "ru": "300px",
        "es": "255px",
        "vi": "200px",
      };
      return widthMap[this.$i18n.locale] || "140px";
    },
  },
  mounted() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  },
  methods: {
    updateWindowDimensions() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
    async submitNew() {
      this.loading = true;
      let query = {
        data: {
          informationSubject: this.dynamicValidateForm.theme,
          vin: this.dynamicValidateForm.vin,
        },
      };
      const res = await newFeedback(query);
      if (res.status == 0) {
        this.dialogShow = false;
        this.loading = false;
        this.$router.push("/quality/list");
      } else {
        this.dialogShow = false;
        this.loading = false;
        this.$DonMessage.warning(res.message)
      }
    },
    confitmDialog() {
      if (this.type == 0) {
        // 提交新建
        this.submitNew();
      }
      if (this.type == 1) {
        // 重置
        this.resetForm("dynamicValidateForm");
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.type = 0;
          this.dialogContent = this.$t("zlfk.submitTxt");
          this.dialogTitle = this.$t("zlfk.submitTitle");
          this.dialogShow = true;
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleReset() {
      this.type = 1;
      this.dialogContent = this.$t("zlfk.reset");
      this.dialogTitle = this.$t("zlfk.resetok");
      this.dialogShow = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-weight: bold;
  margin: 10px 0;
}
.zl-form {
  // width: 800px;
  overflow: hidden;
  ::v-deep .el-form-item__content .el-textarea,
  ::v-deep .el-form-item__content .el-input {
    width: 500px !important;
  }
  // ::v-deep .el-input__inner {
  //   width: 50%;
  // }
}
</style>
